import type { MouseEventHandler } from 'react';
import React, { forwardRef } from 'react';

import { Button } from '@sravni/react-design-system/lib/Button';

import styles from './styles.module.scss';

interface IProps {
  text?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
}

export const AnchorButton = forwardRef<HTMLButtonElement, IProps>(({ text = 'Показать еще', onClick }, ref) => (
  <Button size={44} ref={ref} className={styles.button} variant="outlined" onClick={onClick} block>
    {text}
  </Button>
));

AnchorButton.displayName = 'AnchorButton';
